// GDPR deletion requests (GOD-32), mirrored from functions/src/deletionRequests.ts.

export type DeletionStatus = "open" | "in_progress" | "done" | "rejected";
const STATUSES: DeletionStatus[] = ["open", "in_progress", "done", "rejected"];

/** Requests from before GOD-32 were stored as "pending". */
export function normaliseStatus(status: unknown): DeletionStatus {
    if (status === "pending") return "open";
    return STATUSES.includes(status as DeletionStatus) ? (status as DeletionStatus) : "open";
}

/** Art. 12(3) DSGVO: answer within one month of receipt (same rule as the functions). */
export function dueDateOf(requestedAt: Date): Date {
    const due = new Date(requestedAt);
    const day = due.getUTCDate();
    due.setUTCDate(1);
    due.setUTCMonth(due.getUTCMonth() + 1);
    const lastDay = new Date(Date.UTC(due.getUTCFullYear(), due.getUTCMonth() + 1, 0)).getUTCDate();
    due.setUTCDate(Math.min(day, lastDay));
    return due;
}

const DAY_MS = 24 * 60 * 60 * 1000;

/**
 * Where a request stands against its deadline: finished requests have none,
 * otherwise whole days left (0 = due today) or days overdue.
 */
export function deadlineState(
    status: DeletionStatus,
    due: Date,
    now: Date
): { kind: "finished" } | { kind: "open"; days: number } | { kind: "overdue"; days: number } {
    if (status === "done" || status === "rejected") return { kind: "finished" };
    const days = Math.ceil((due.getTime() - now.getTime()) / DAY_MS);
    return days < 0 ? { kind: "overdue", days: -days } : { kind: "open", days };
}
